import { createAsyncThunk } from "@reduxjs/toolkit";

import type { NapiClient } from "@app/services/api";
import {
  clickedRedeemCredits,
  redeemCreditsError
} from "@app/tracking/checkout-tracking";
import type { Tracker } from "@app/tracking/tracker";
import type { CheckoutReduxStateV2 } from "@app/types/checkout-v2-types";

import {
  pollCartV2Begin,
  pollCartV2Failure,
  pollCartV2Success
} from "../slices/cart";

interface RedeemCreditsParams {
  api: NapiClient;
  tracker: Tracker;
}

export const redeemCredits = createAsyncThunk<
  Promise<any>,
  RedeemCreditsParams,
  { state: CheckoutReduxStateV2 }
>(
  "checkout/redeemCredits",
  async ({ api, tracker }, { getState, dispatch }) => {
    dispatch(pollCartV2Begin());

    tracker.track(clickedRedeemCredits());

    const {
      cart: { id }
    } = getState();

    return api
      .postRedeemCartReward(id)
      .then(async () => {
        const response = await api.pollCartV2(id);
        if (response) {
          dispatch(pollCartV2Success(response));
        }
      })
      .catch((err: Error) => {
        tracker.track(redeemCreditsError("redeem_error"));

        dispatch(pollCartV2Failure(err));
        throw err;
      });
  }
);

export const unredeemCredits = createAsyncThunk<
  Promise<any>,
  RedeemCreditsParams,
  { state: CheckoutReduxStateV2 }
>(
  "checkout/unredeemCredits",
  async ({ api, tracker }: RedeemCreditsParams, { getState, dispatch }) => {
    dispatch(pollCartV2Begin());

    tracker.track(clickedRedeemCredits());

    const {
      cart: { id }
    } = getState();

    return api
      .postUnredeemCartReward(id)
      .then(async () => {
        const response = await api.pollCartV2(id);
        if (response) {
          dispatch(pollCartV2Success(response));
        }
      })
      .catch((err: Error) => {
        tracker.track(redeemCreditsError("redeem_error"));

        dispatch(pollCartV2Failure(err));
        throw err;
      });
  }
);
